import { useAnalytics } from '@/hooks/useAnalytics';

/** Invisible analytics tracker — must live inside BrowserRouter. */
export default function AnalyticsTracker() {
  useAnalytics();
  return null;
}
